"use client";

import { useMutation } from "@tanstack/react-query";
import { CART_WRITE_SCOPE } from "@/features/cart/api/hooks/use-update-cart";
import type { Cart } from "@/features/cart/types";
import type { DateMoves } from "@/features/cart/utils/reschedule-dates";
import { ApiError } from "@/lib/helpers/errors";

type RescheduleCartPayload = {
  cartId: string;
  moves: DateMoves;
};

type RescheduleCartResponse = {
  cart: Cart;
  cartId: string;
};

export const useRescheduleCart = () =>
  useMutation({
    scope: { id: CART_WRITE_SCOPE },
    mutationFn: async (body: RescheduleCartPayload) => {
      const response = await fetch("/api/cart/reschedule", {
        body: JSON.stringify(body),
        method: "POST",
      });

      if (!response.ok) {
        const error = (await response.json().catch(() => null)) as {
          error?: string;
        } | null;

        throw new ApiError(
          error?.error ?? "cart_reschedule_failed",
          response.status,
          error,
        );
      }

      return (await response.json()) as RescheduleCartResponse;
    },
  });
